<template>
  <div id="legalNotice" class="d-flex flex-column justify-content-around align-items-left" v-if="legalNoticeLg.lg1.length > 0">
    <div id="bloc1" v-if="legalNoticeLg.lg1">
      <span class="lg1" v-html="rawHtml(legalNoticeLg.lg1[0].ta_value)"></span> 
      <span class="lg2" v-html="rawHtml(legalNoticeLg.lg2[0].ta_value)"></span> 
    </div>
    <div id="bloc2" v-if="legalNoticeLg.lg1.length > 1">
      <div>
        <span class="lg1" v-html="rawHtml(legalNoticeLg.lg1[1].ta_value)"></span> 
        <span class="lg2" v-html="rawHtml(legalNoticeLg.lg2[1].ta_value)"></span> 
      </div>
      <div v-if="legalNoticeLg.lg1.length > 2">
        <div class="lg1" v-html="rawHtml(legalNoticeLg.lg1[2].ta_value)"></div>
        <div class="lg2" v-html="rawHtml(legalNoticeLg.lg2[2].ta_value)"></div>
      </div>
    </div>
    <div id="bloc3" v-if="legalNoticeLg.lg1.length > 3">
      <div class="lg1" v-html="rawHtml(legalNoticeLg.lg1[3].ta_value)"></div>
      <div class="lg2" v-html="rawHtml(legalNoticeLg.lg2[3].ta_value)"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MercureRatesHorizontalV1LegalNoticeLeft',
  props: {
    legalNoticeLg: Object
  },
  methods: {
    rawHtml (value) {
      return value
    }
  }
}
</script>


<style lang="scss" scoped>
  $srcWidth: 1920;
  $srcHeight: 1200;
  @import "../../../../_mercure.scss";

  #legalNotice {
    font-family: "National-Medium";
    @include fontSize(26);
    line-height: 1rem;

    position: absolute;
    bottom: 0px;
    @include widthPercent(895);
    @include heightPercent(270);
    justify-content: space-evenly!important;

    #bloc2, #bloc3 {
      //margin-top: 0.8rem;
    }

    span+span:not(:empty):before {
      content: '- ';
    }
  }

</style>


// WEBPACK FOOTER //
// src/components/mercure/rates/horizontal/v1/rates/legalNoticeLeft.vue